// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"763":"8a4c32af","4494":"8a4c32af","6564":"8a4c32af","7835":"8a4c32af","8765":"8a4c32af"}[chunkId] + ".chunk.css";
};